import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SortEvent } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { filter, tap } from 'rxjs/operators';
import { AnalyticsStructurePieResult, AnalyticsStructureSingleValue } from 'src/app/models/ianalytics.interface';
import { INewName } from 'src/app/models/inewname.interface';
import { IRenameEvent } from 'src/app/models/irenameevent.interface';
import { ExcelService } from 'src/app/services/common/excel.service';
import { RenameComponent } from '../rename/rename.component';

@UntilDestroy()
@Component({
  selector: 'app-structure-table-prime',
  templateUrl: './structure-table-prime.component.html',
  styleUrls: ['./structure-table-prime.component.css'],
  providers: [DialogService],
})
export class StructureTablePrimeComponent implements OnInit, OnChanges {
  @Input() categoryName: string = '';
  @Input() stat: AnalyticsStructurePieResult;

  @Output() renamed = new EventEmitter<IRenameEvent>();

  @ViewChild('dt') _tbl: Table;

  get isCanEdit() {
    return this.stat.field !== '';
  }

  constructor(
    private _excel: ExcelService,
    private _dlg: DialogService,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(ch: SimpleChanges) {

  }

  onExcel(data: any[]) {
    // console.log(this._tbl._value);
    const items: AnalyticsStructureSingleValue[] = [...data];
    items.push({ key: 'ИТОГО', value: this.stat.n, percent: 100 } as AnalyticsStructureSingleValue);
    this._excel.exportExcel(this.stat.caption, items, [], ['Значение', 'Кол-во', '%']);
  }

  onReplace(val: string) {
    const ref = this._dlg.open(RenameComponent, {
      data: {
        item: { name: val } as INewName,
        isAdd: false
      },
      header: `Заменить ${val} на ...`,
      width: '70%',
    });

    ref.onClose.pipe(
      untilDestroyed(this),
      filter(data => data),
      tap((data: INewName) => {
        const obj: IRenameEvent = { field: this.stat.field, oldvalue: val, newvalue: data.name };
        this.renamed.emit(obj);
      })
    ).subscribe();
  }
}
